import AdminLayout from "../../../components/admin/layout/AdminLayout";
import AdminDocumentTable from "../../../components/admin/document/AdminDocumentTable";

//어드민 문서 메인 페이지
const AdminDocumentMainPage: React.FC = () => {
    return (
        <AdminLayout>
            {/*어드민 문서 테이블*/}
            <AdminDocumentTable/>
            {/*/!*어드민 자동생성 보고서 테이블*!/*/}
            {/*<AdminConfirmTable/>*/}
        </AdminLayout>
    )
}

export default AdminDocumentMainPage;